module.exports = __webpack_public_path__ + "static/media/iconStudentsF.c2f3ac5b.svg";